import React from 'react'
import Layout from '../../components/common/layout'
import Services from '../../components/services'
import SEO from '../../components/common/seo'

const ServicesPage = () => (
  <Layout>
    <SEO title="San Diego Refrigeration &amp; A/C Repair" />
    <Services />
  </Layout>
)

export default ServicesPage
